import { isValidElement } from 'react'

/**
 * Attempts to extract text from a React node.
 */
export function extractReactNodeText(children: React.ReactNode): string {
  if (children === null) return ''
  if (children === undefined) return ''
  if (typeof children === 'boolean') return String(children)
  if (typeof children === 'string') return children
  if (typeof children === 'number') return String(children)

  if (isValidElement<{ children?: React.ReactNode }>(children)) {
    const nestedChildren = children.props.children
    return nestedChildren === undefined ? '' : extractReactNodeText(children.props.children)
  }

  if (Array.isArray(children)) {
    return children.map(extractReactNodeText).join('')
  }

  return ''
}
